import axios from 'axios';
import { API_URL } from '../config/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true
});

export interface Event {
  _id?: string;
  eventCode: string;
  eventName: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateEventData {
  eventName: string;
}

export interface UpdateEventData {
  eventName: string;
}

// Tạo sự kiện mới
export const createEvent = async (data: CreateEventData) => {
  const response = await api.post<{
    success: boolean;
    message: string;
    event: Event;
  }>('/events', data);
  return response.data;
};

// Lấy danh sách sự kiện của user hiện tại
export const getMyEvents = async () => {
  const response = await api.get<{
    success: boolean;
    events: Event[];
  }>('/events/my-events');
  return response.data;
};

// Lấy thông tin chi tiết sự kiện
export const getEvent = async (eventCode: string) => {
  const response = await api.get<{
    success: boolean;
    event: Event;
  }>(`/events/${eventCode}`);
  return response.data;
};

// Cập nhật sự kiện
export const updateEvent = async (eventCode: string, data: UpdateEventData) => {
  const response = await api.put<{
    success: boolean;
    message: string;
    event: Event;
  }>(`/events/${eventCode}`, data);
  return response.data;
};

// Xóa sự kiện
export const deleteEvent = async (eventCode: string) => {
  const response = await api.delete<{
    success: boolean;
    message: string;
  }>(`/events/${eventCode}`);
  return response.data;
};

// Lấy tất cả sự kiện (ADMIN)
export const getAllEvents = async (page = 1, limit = 20, search = '') => {
  const response = await api.get<{
    success: boolean;
    events: Event[];
    pagination: {
      page: number;
      limit: number;
      total: number;
      pages: number;
    };
  }>('/events/all/list', {
    params: { page, limit, search }
  });
  return response.data;
};
